module.exports = __webpack_public_path__ + "static/media/grid only 2.ebe419b6.png";